<template>
    <div class="staff-container container-1200">
        <PageTitle :title="'Global Representative'"></PageTitle>
        <div class="staff-list">
            <el-card v-for="(staff, index) in staffList" :key="index" class="staff-card" shadow="hover">
                <div class="staff-avatar">
                    <img :src="staff.image" :class="staff.cv ? 'staff_imagehov' : ''" @click="goToBlank(staff.cv)" />
                </div>

                <div class="staff-info">
                    <strong class="staff-name">{{ staff.name }}</strong>
                    <div class="staff-reg">{{ staff.title }}</div>
                    <div class="staff-region" v-if="staff.region">-{{ staff.region }}</div>
                    <a :href="'mailto:' + staff.email" class="staff-email">{{ staff.email }}</a>
                    <div v-if="staff.phone" class="staff-phone">{{ staff.phone }}</div>
                    <div v-if="staff.whatsapp" class="staff-whatsapp">
                        WhatsApp:<br />
                        <a :href="'https://wa.me/' + staff.whatsapp.replace(/\s+/g, '')">
                            {{ staff.whatsapp }}
                        </a>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import PageTitle from "@/components/pageTitle/index.vue"

export default {
    name: "StaffList",
    components: {
        PageTitle
    },
    data() {
        return {
            staffList: [
                {
                    name: 'Dr. Amin D. Malayeri',
                    title: 'Senior consultant, Development executive',
                    region: "Middle East",
                    image: require('@/assets/images/team/Amin.png'),
                    whatsapp: "",
                    email: "amin.daneshmand@contrimetric.com",
                    cv: "https://contrimetric.com/logo/curriculum_vitae/Amin's brief bio.pdf"
                },
                {
                    name: 'Afarand Scholarly Publishing Institute',
                    title: 'Strategic Partnerships',
                    region: "Iran",
                    image: require('@/assets/images/team/aspi.png'),
                    whatsapp: "",
                    email: "afarand@contrimetric.com",
                    cv: "https://daneshafarand.org/"
                }
            ]
        };
    },
    methods: {
        goToBlank(url) {
            if (url) {
                window.open(url, "_blank");
            }
        }
    }
};
</script>

<style scoped lang="scss">
.staff-container {
    padding: 20px;
    min-height: 700px;
}

.staff-title {
    font-size: 24px;
    font-weight: bold;
    border-bottom: 3px solid #00bcd4;
    width: fit-content;
    margin: 0 auto;
    padding-bottom: 2px;
    margin-bottom: 20px;

}

.staff-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.staff-card {
    width: calc(33% - 32px);
    padding: 10px;
    border-radius: 10px;
    min-height: 210px;
}

.staff-avatar {
    min-height: 210px;
    width: 45%;

    img {
        width: 150px;
        height: 210px;
        border-radius: 10px;
        object-fit: cover;
    }

    .staff_imagehov {
        &:hover {
            cursor: pointer;
        }
    }
}

.staff-phone {
    padding: 4px 0;
}

.staff-info {
    flex: 1;
    margin-top: 10px;
    font-size: 14px;
    word-break: break-word;
    line-height: 24px;
}

.staff-name {
    font-size: 18px;
}

.staff-reg {
    font-size: 16px;
    color: #333;
}

.staff-region {
    color: #999;
    margin: 4px 0;
}



.staff-email,
.staff-region a {
    color: #333;
    text-decoration: underline;

}

.staff-whatsapp {
    padding-top: 4px;
}
</style>
<style scoped lang="scss">
::v-deep .el-card__body {
    display: flex;
    align-items: center;
    padding: 0;
    gap: 10px;
}
</style>

<style scoped lang="scss">
@media screen and (max-width: 1024px) {
    .staff-card {
        width: 46%;
        min-height: unset !important;
    }

    .staff-avatar {
        // width: 30%;
        min-height: unset !important;
    }
}

/* 手机端竖屏 */
@media screen and (max-width: 768px) {
    .staff-card {
        width: 100%;
    }

    .staff-avatar {
        width: 35%;

        img {
            width: 120px;
            height: 150px;
        }
    }
}
</style>